import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../request.js";
import e from "../../core/Error.js";
import i from "../../core/Logger.js";
import { urlToObject as s, objectToQuery as a } from "../../core/urlUtils.js";
var r = i.getLogger("esri.layers.support.SpriteSource"),
    h = 1.15;

var o = /*#__PURE__*/function () {
  function o(t, e, i, s) {
    _classCallCheck(this, o);

    this.baseURL = t, this.devicePixelRatio = e, this.maxTextureSize = i, this._spriteImageFormat = s, this._isRetina = !1, this._spritesData = {}, this.image = null, this.width = null, this.height = null, this.loadStatus = "not-loaded";
  }

  _createClass(o, [{
    key: "spriteNames",
    get: function get() {
      var t = [];

      for (var _e in this._spritesData) {
        t.push(_e);
      }

      return t.sort(), t;
    }
  }, {
    key: "getSpriteInfo",
    value: function getSpriteInfo(t) {
      return this._spritesData[t];
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.baseURL) {
                  _context.next = 13;
                  break;
                }

                this.loadStatus = "loading";
                _context.prev = 2;
                _context.next = 5;
                return this._loadSprites(t);

              case 5:
                this.loadStatus = "loaded";
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                this.loadStatus = "failed";

              case 11:
                _context.next = 14;
                break;

              case 13:
                this.loadStatus = "failed";

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function load(_x) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "_loadSprites",
    value: function _loadSprites(i) {
      var _this = this;

      this._isRetina = this.devicePixelRatio > h;

      var _o = s(this.baseURL),
          l = _o.query ? "?" + a(_o.query) : "",
          n = this._isRetina ? "@2x" : "",
          d = "".concat(_o.path).concat(n, ".").concat(this._spriteImageFormat).concat(l),
          g = "".concat(_o.path).concat(n, ".json").concat(l);

      return Promise.all([t(g, i), t(d, _objectSpread({
        responseType: "image"
      }, i))]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            t = _ref2[0],
            i = _ref2[1];

        var s = Object.keys(t.data);
        if (!s || 0 === s.length || 1 === s.length && "_ssl" === s[0] || !i || !i.data) return _this._spritesData = _this.image = null, _this.width = _this.height = 0, Promise.resolve(null);
        _this._spritesData = t.data;
        var a = i.data,
            h = Math.max(_this.maxTextureSize, 4096);

        if (a.width > h || a.height > h) {
          var _t = "Sprite resource for style ".concat(_o.path, " is bigger than the maximum allowed of ").concat(h, " pixels}");

          throw r.error(_t), new e("SpriteSource", _t);
        }

        _this.width = a.width, _this.height = a.height;
        var l = document.createElement("canvas"),
            n = l.getContext("2d");
        l.width = a.width, l.height = a.height, n.drawImage(a, 0, 0, a.width, a.height);
        var d = n.getImageData(0, 0, a.width, a.height),
            g = new Uint8Array(d.data);
        var m;

        for (var _e2 = 0; _e2 < g.length; _e2 += 4) {
          m = g[_e2 + 3] / 255, g[_e2] = g[_e2] * m, g[_e2 + 1] = g[_e2 + 1] * m, g[_e2 + 2] = g[_e2 + 2] * m;
        }

        _this.image = g;
      });
    }
  }]);

  return o;
}();

export { o as default };